<script setup>
import { computed } from 'vue'
import ActionMenuButton from '../src/ActionMenuButtonMenu.vue'
import { extActionButtonMenuProps } from '../src/props'
import { DEFAULT_FONT_SIZE_VALUE } from '@/tiptap/constants/define'

const props = defineProps(extActionButtonMenuProps())

const items = computed(() => {
  const fontSizes = (props.extension?.options?.fontSizes) || []
  const all = [DEFAULT_FONT_SIZE_VALUE, ...fontSizes]

  return all.map(k => ({
    title: k === DEFAULT_FONT_SIZE_VALUE ? props.t('editor.default') : String(k),
    isActive: () => {
      const hasTextStyle = !!props.editor?.schema?.marks?.textStyle
      if (!hasTextStyle) return false
      const { fontSize } = props.editor.getAttributes('textStyle')
      const isDefault = k === DEFAULT_FONT_SIZE_VALUE
      const notFontSize = fontSize === undefined
      if (isDefault && notFontSize) return true
      return props.editor.isActive?.('textStyle', { fontSize: String(k) }) || false
    },
    action: () => {
      const chain = props.editor.chain().focus()
      if (k === DEFAULT_FONT_SIZE_VALUE) {
        if (chain.unsetFontSize) chain.unsetFontSize().run()
        return
      }
      if (chain.setFontSize) chain.setFontSize(String(k)).run()
    },
    divider: k === DEFAULT_FONT_SIZE_VALUE,
    default: k === DEFAULT_FONT_SIZE_VALUE,
  }))
})
</script>

<template>
  <ActionMenuButton
    :editor="editor"
    :items="items"
    :max-height="280"
    :disabled="!(
      editor?.schema?.marks?.textStyle &&
      editor?.can?.().setFontSize ? editor.can().setFontSize('16px') : false
    )"
    :tooltip="t('editor.fontSize.tooltip')"
    icon="fontSize"
  />
</template>